import React, { useState, useCallback, useMemo } from 'react';

function ModernPesquisar({ callback, placeholder = "Pesquisar produtos..." }) {
    const [searchText, setSearchText] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    // Debounce para evitar muitas requisições
    const debounce = useCallback((func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(null, args), delay);
        };
    }, []);

    const debouncedSearch = useMemo(() => debounce((text) => {
        setIsSearching(true);
        if (callback) {
            callback(text);
        }
        setTimeout(() => setIsSearching(false), 500);
    }, 300), [callback, debounce]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value);
        debouncedSearch(value);
    };

    const handleClear = () => {
        setSearchText('');
        if (callback) {
            callback('');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        debouncedSearch(searchText);
    };

    return (
        <form onSubmit={handleSubmit} className="position-relative modern-search">
            <div className="input-group modern-search-group">
                <span className="input-group-text modern-search-addon border-end-0">
                    {isSearching ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Pesquisando...</span>
                        </div>
                    ) : (
                        <i className="bi bi-search"></i>
                    )}
                </span>
                
                <input
                    type="text"
                    className="form-control form-control-modern border-start-0 modern-search-input"
                    placeholder={placeholder}
                    value={searchText}
                    onChange={handleInputChange}
                    aria-label="Campo de pesquisa"
                />
                
                {searchText && (
                    <button
                        type="button"
                        className="btn modern-search-clear border-0 position-absolute end-0 top-50 translate-middle-y me-2"
                        onClick={handleClear}
                        aria-label="Limpar pesquisa"
                        style={{ zIndex: 10 }}
                    >
                        <i className="bi bi-x-circle"></i>
                    </button>
                )}
            </div>
            
            {/* Sugestões de pesquisa - pode ser expandido no futuro */}
            {searchText && (
                <div className="position-absolute w-100 mt-1" style={{ zIndex: 1000 }}>
                    {/* Aqui podem ser adicionadas sugestões de pesquisa */}
                </div>
            )}
        </form>
    );
}

export default ModernPesquisar;
